import { Box, Center, Heading, Spinner, Tab, TabList, Tabs, Text, VStack } from '@chakra-ui/react';
import { kebabCaseToSpaceSeperate } from '@utils';
import { TAB_STATES } from './utils';
import WorkflowDocsCardV2 from '@components/WorkflowDocCard/WorkflowDocsCardV2';
import { memo } from 'react';
import Pagination from '@components/Pagination';
import { handleViewDocClick } from '@store/actions/workflowActions';
import { useDispatch } from 'react-redux';

const TabSection = ({
    selectedTab,
    onTabChange,
    docs = [],
    totalPages = 0,
    currentPage = 1,
    onPageChange,
    isLoading,
    isError,
    error,
    onViewRejectionReason
}) => {
    const dispatch = useDispatch();
    return (
        <>
            <Tabs
                variant={"enclosed"}
                size={"md"}
                index={Object.keys(TAB_STATES).indexOf(selectedTab)}
                onChange={onTabChange}
            >
                <TabList color={'whiteAlpha.700'} borderColor={'whiteAlpha.500'}>
                    {Object.keys(TAB_STATES).map((tabState, ind) => (
                        <Tab
                            key={ind}
                            _selected={{
                                color: 'brand.500',
                                border: '1px solid',
                                borderColor: 'whiteAlpha.500',
                                borderBottom: '1px solid black'
                            }}
                        >
                            {kebabCaseToSpaceSeperate(tabState)}
                        </Tab>
                    ))}
                </TabList>
            </Tabs>
            {totalPages > 0 && (
                <Box alignSelf={'start'}>
                    <Pagination
                        totalPages={totalPages}
                        currentPage={currentPage}
                        onPageChange={onPageChange}
                    />
                </Box>
            )}
            {isLoading ? (
                <Center py={8}>
                    <Spinner color='brand.500' />
                </Center>
            ) : isError ? (
                <Box
                    color="red.500"
                    p={4}
                    borderRadius="xl"
                    bg={'backGround'}
                    borderWidth="1px"
                    borderColor={'whiteAlpha.300'}
                >
                    <Text>An error occurred while fetching data: {error}</Text>
                </Box>
            ) : (
                <VStack alignSelf={'flex-start'} maxW={'100%'} gap={1}>
                    {docs?.length > 0 ? (
                        docs.map((item, i) => (
                            <WorkflowDocsCardV2
                                key={i}
                                referenceId={item?.referenceId}
                                documentId={item?.documentId}
                                documentSource={item?.documentSource}
                                isRejected={item?.rejected}
                                rejectionReason={item?.rejectionReason}
                                createdAt={item?.createdAt}
                                onViewRejectionReason={onViewRejectionReason}
                                onViewDocClick={() => dispatch(handleViewDocClick(item?.urlPath))}
                            />
                        ))
                    ) : (
                        <Center py={10} w="100%">
                            <Heading size="md" color="gray.400">
                                No documents found
                            </Heading>
                        </Center>
                    )}
                </VStack>)}
        </>)
};
export default memo(TabSection);